export default "__VITE_ASSET__lnFRTBTK__"